import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {Product} from '../models/product';

export const productsActionTypes = {
  LOAD: type('[Products] Load'),
  LOAD_BY_SERVICE: type('[Products] Load By Service'),
  LOAD_SUCCESS: type('[Products] Load Success'),
  LOAD_FAIL: type('[Products] Load Error')
};

export class LoadProductsAction implements Action {
  readonly type = productsActionTypes.LOAD;
  constructor() {}
}
export class LoadProductsByServiceAction implements Action {
  readonly type = productsActionTypes.LOAD_BY_SERVICE;
  constructor(public payload?: number) {}
}


export class LoadProductsSuccessAction implements Action {
  readonly type = productsActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Product[]) {}
}

export class LoadProductsFailAction implements Action {
  readonly type = productsActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
